"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _common = require("../../../core/utils/common");
var renderUserName = function renderUserName(props) {
  var userName = props.userName,
    ePRocMyAccount = props.ePRocMyAccount;
  return _react.default.createElement(_react.default.Fragment, null, userName && _react.default.createElement("div", {
    className: "my-account-dropdown__user-details__name",
    "data-locator": ePRocMyAccount ? 'my-account-dropdown-user-greeting-name' : 'header-section-user-name'
  }, userName));
};
var renderAccountDetails = function renderAccountDetails(props) {
  var accountName = props.accountName,
    ePRocMyAccount = props.ePRocMyAccount,
    company = props.company;
  if (!accountName) return _react.default.createElement(_react.default.Fragment, null);
  return _react.default.createElement(_react.default.Fragment, null, accountName && _react.default.createElement("div", {
    className: "my-account-dropdown__user-details__account"
  }, accountName && _react.default.createElement("span", {
    className: "my-account-dropdown__user-details__account__name",
    "data-locator": ePRocMyAccount ? 'my-account-dropdown-user-greeting-company' : 'header-user-account-name'
  }, ePRocMyAccount ? (0, _common.htmlParser)(company) : accountName)));
};
var renderSwitchAccountLink = function renderSwitchAccountLink(props) {
  var soldTo = (0, _get.default)(props, 'userDetails.soldTo', []);
  var removeLastPartFromUrl = function removeLastPartFromUrl(url) {
    var splitUrl = url.split('/');
    splitUrl.pop();
    return splitUrl.join('/');
  };
  var currentPath = window.location.pathname;
  var isConfirmationPage = currentPath === removeLastPartFromUrl(currentPath) + "/order-confirmation";
  var isReviewOrderPage = currentPath === removeLastPartFromUrl(currentPath) + "/checkout-review";
  var switchAccount = props.switchAccount;
  var _switchAccount$isHidd = switchAccount.isHidden,
    isHidden = _switchAccount$isHidd === void 0 ? false : _switchAccount$isHidd;
  if (soldTo.length < 2) return _react.default.createElement(_react.default.Fragment, null);
  return _react.default.createElement(_react.default.Fragment, null, switchAccount.text && switchAccount.url && !isHidden && !isReviewOrderPage && !isConfirmationPage && _react.default.createElement("a", {
    className: "my-account-dropdown__user-details__switch-account",
    href: switchAccount.url,
    onClick: switchAccount.onClick,
    "data-locator": "header-user-dropdown-switch-account-link"
  }, switchAccount.text));
};
var renderUserCompanyLogo = function renderUserCompanyLogo(props) {
  var renderCompanyLogo = props.renderCompanyLogo;
  return _react.default.createElement(_react.default.Fragment, null, renderCompanyLogo && _react.default.createElement("div", {
    className: "my-account-dropdown__user-details__logo"
  }, renderCompanyLogo(props)));
};
var MyAccountUserDetails = function MyAccountUserDetails(props) {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: "my-account-dropdown__user-details",
    "data-locator": "my-account-dropdown__user-details"
  }, renderUserName(props), renderAccountDetails(props), renderUserCompanyLogo(props), renderSwitchAccountLink(props)), _react.default.createElement("hr", {
    className: "my-account-dropdown__hr"
  }));
};
renderUserCompanyLogo.defaultProps = {
  renderCompanyLogo: function renderCompanyLogo() {
    /* default renderCompanyLogo handler */
  }
};
renderUserName.defaultProps = {
  userName: '',
  ePRocMyAccount: false
};
renderAccountDetails.defaultProps = {
  accountName: '',
  ePRocMyAccount: false
};
renderSwitchAccountLink.defaultProps = {
  switchAccount: {}
};
var _default = MyAccountUserDetails;
exports.default = _default;
module.exports = exports["default"];